import React from 'react';
import LanguageOption from './LanguageOption/LanguageOption';
import { Link } from 'react-router-dom';
import LoginOption from '../LoginOption/LoginOption';
import LoginLinksData from '../../Data/LoginLinks';
import './Header.scss';
const Header = () => {
  return (
    <header>
      <div className="container">
        <div className="header-container">
          <div className="logo">
            <img className="focalx-logo" src='/Assets/images/vascor-logo.svg' alt='VASCOR Logo' />
          </div>
          <div className='header-action-buttons'>
            <Link className="custom-btn-secondary login-button" to="https://tenant.focalx.ai/" target="_blank">
                Login
              </Link>          
            {/* <LoginOption options={LoginLinksData} />  */}
            {/* <LanguageOption /> */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
